module.exports = __webpack_public_path__ + "media/images/favicon-48x48-51c8376b82a08d273f6a6ed90b964351.png";